import React from 'react';

import { TextSettings } from './text';
import { VideoSettings } from './video';

export const Settings: React.FC = () => {
  return (
    <div className={'reels-settings-container'}>
      <VideoSettings />
      <TextSettings />
    </div>
  );
};
